import { conditions } from "helpers";
import IMAGES from "images";
import { ConditionName, IChatDefaultMessages } from "interfaces";
import Image from "next/image";
import { MouseEvent, memo, useEffect, useRef, useState } from "react";
import { shallowEqual } from "react-redux";
import { submitCommentInChat, useAppSelector } from "redux-share";

const DefaultMessages = () => {
    const chatContainerRef = useRef<any>();
    const { emojis } = useAppSelector(({ videoData: { emojis } }) => ({ emojis }), shallowEqual);
    const { defaultMessages } = useAppSelector(({ chats: { defaultMessages } }) => ({ defaultMessages }), shallowEqual);

    const [scrollPosition, setScrollPosition] = useState<number>(0);
    const [showLeftScrollIcon, setShowLeftScrollIcon] = useState<boolean>(false);
    const [showRightScrollIcon, setShowRightScrollIcon] = useState<boolean>(false);

    const handleClickPrev = (event: MouseEvent<HTMLParagraphElement>) => {
        event.stopPropagation();
        const newScrollPosition = scrollPosition + chatContainerRef.current.clientWidth;
        if (chatContainerRef.current.scrollLeft >= 0) {
            setShowRightScrollIcon(false);
            setShowLeftScrollIcon(true);
        } else {
            setScrollPosition(newScrollPosition);
            chatContainerRef.current.scrollLeft = newScrollPosition;
            setShowRightScrollIcon(true);
            setShowLeftScrollIcon(true);
        }
    };

    const handleClickNext = (event: MouseEvent<HTMLParagraphElement>) => {
        event.stopPropagation();
        const newScrollPosition = scrollPosition - chatContainerRef.current.clientWidth;
        if (chatContainerRef.current.clientWidth + Math.abs(chatContainerRef.current.scrollLeft) >= chatContainerRef.current.scrollWidth - 1)
            setShowLeftScrollIcon(false);
        else {
            setScrollPosition(newScrollPosition);
            chatContainerRef.current.scrollLeft = newScrollPosition;
            setShowRightScrollIcon(true);
        }
    };

    useEffect(() => {
        if (chatContainerRef.current.scrollWidth > chatContainerRef.current.clientWidth) setShowLeftScrollIcon(true);
        else {
            setShowLeftScrollIcon(false);
            setShowRightScrollIcon(false);
        }
    }, [defaultMessages.length]);

    return (
        <div
            className={`pl-relative ${
                conditions(ConditionName.isComplexPortrait)
                    ? `pl-order-3 ${emojis.emoji_list_2 !== "" && "pl-mr-[30px]"} ${emojis.emoji_list_1 !== "" && "pl-ml-[30px]"}`
                    : "pl-order-1"
            }`}
        >
            <div className="pl-group pl-flex pl-items-center pl-gap-2 pl-overflow-auto no-scrollbar" ref={chatContainerRef}>
                {defaultMessages.map((item: IChatDefaultMessages) => (
                    <div
                        key={item.id}
                        className="pl-flex pl-items-center pl-gap-2 pl-bg-gray-highLight dark:pl-bg-z-gray-500 pl-rounded-[16px] pl-px-4 pl-py-1 pl-cursor-pointer"
                        onClick={() => submitCommentInChat(undefined, undefined, item.id)}
                    >
                        <p className="pl-text-[12px] pl-font-normal pl-text-gray-800 dark:pl-text-white pl-whitespace-nowrap">{item.message}</p>
                    </div>
                ))}
                {!conditions(ConditionName.isTouchScreen) && (
                    <>
                        <div
                            className={`pl-absolute pl-cursor-pointer pl-right-0 pl-top-1 ${
                                !showRightScrollIcon && "pl-opacity-0 pl-pointer-events-none"
                            }`}
                        >
                            <Image
                                src={conditions(ConditionName.isDarkMode) ? IMAGES.leftArrow : IMAGES.lightLeftArrow}
                                width={15}
                                height={15}
                                alt="left-arrow"
                                onClick={handleClickPrev}
                                onDoubleClick={(event: any) => event.stopPropagation()}
                            />
                        </div>
                        <div
                            className={`pl-absolute pl-cursor-pointer pl-left-0 pl-top-1 ${
                                !showLeftScrollIcon && "pl-opacity-0 pl-pointer-events-none"
                            }`}
                        >
                            <Image
                                src={conditions(ConditionName.isDarkMode) ? IMAGES.rightArrow : IMAGES.lightRightArrow}
                                width={15}
                                height={15}
                                alt="right-arrow"
                                onClick={handleClickNext}
                                onDoubleClick={(event: any) => event.stopPropagation()}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default memo(DefaultMessages);
